/** Abas simples (role=tablist). O painel ativo é renderizado pelo pai. */
import { createElement as h, type ReactElement } from "react";
import { cx } from "./cx.js";

export interface TabItem<T extends string> {
  id: T;
  label: string;
  count?: number;
}

export interface TabsProps<T extends string> {
  label: string;
  active: T;
  tabs: Array<TabItem<T>>;
  onChange: (id: T) => void;
}

export function Tabs<T extends string>({ label, active, tabs, onChange }: TabsProps<T>): ReactElement {
  return h(
    "div",
    { role: "tablist", "aria-label": label, className: "flex gap-1 overflow-x-auto border-b border-border" },
    tabs.map((tab) =>
      h(
        "button",
        {
          key: tab.id,
          type: "button",
          role: "tab",
          "aria-selected": tab.id === active,
          onClick: () => onChange(tab.id),
          className: cx(
            "-mb-px min-h-[40px] whitespace-nowrap border-b-2 px-3 text-sm focus-visible:outline-none",
            tab.id === active ? "border-brand font-bold text-ink" : "border-transparent font-medium text-muted hover:text-ink"
          )
        },
        tab.count === undefined ? tab.label : `${tab.label} (${tab.count})`
      )
    )
  );
}
